export const PHONE_NUMBER = '12 99753-0395'
